<script lang="ts">
	import { type Snippet, onMount } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import type { Media } from "@core/schema/Media.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { refreshAndInitializeLightbox } from "@core/utils/refreshAndInitializeLightbox.js";
	import { thumbUploadedFile } from "@core/utils/thumbUploadedFile.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const {
		caption,
		class: customClass,
		id,
		type,
		children,
		source,
	}: {
		caption?: string;
		class?: ClassValue;
		id?: string;
		type: "image" | "video" | "youtube";
		children?: Snippet;
		source: { href: string } | { media: Media; width: number };
	} = $props();

	onMount(() => {
		void refreshAndInitializeLightbox();
	});

	function update(_value: typeof source): void {
		if (typeof window !== "undefined") {
			void refreshAndInitializeLightbox();
		}
	}

	const { FILE_BUCKET_URL_MAP } = getGlobalSettings();

	$effect(() => {
		update(source);
	});

	const href = $derived.by<string>(() => {
		if ("href" in source) {
			return source.href;
		} else {
			if (source.media.type.startsWith("video")) {
				return getUploadedFilePath(source.media, FILE_BUCKET_URL_MAP);
			} else {
				return thumbUploadedFile(source.width, 0, source.media, FILE_BUCKET_URL_MAP);
			}
		}
	});
</script>

<svelte:head>
	{#if type === "image"}
		<link rel="preload" {href} as="image" fetchpriority="low" />
	{/if}
</svelte:head>

<a {href} class={customClass} data-fslightbox={id ?? ""} data-type={type} data-caption={caption}>
	{@render children?.()}
</a>
